<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <label class="search-label">业务员</label>
          <Select v-model="userId" class="search-input" clearable>
            <Option v-for="item in userIds" :value="item.id" :key="item.id">{{
              item.real_name
            }}</Option>
          </Select>
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
        <Col span="4" class="search-right">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="addModal"
      title="添加客户"
      footer-hide
    >
      <forms
        ref="addChild"
        :resetFlag="resetFlag"
        @on-ok="addSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="editModal"
      title="编辑客户"
      footer-hide
    >
      <forms
        ref="editChild"
        :resetFlag="resetFlag"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal v-model="showCodeModal" footer-hide :closable="false" :width="335">
      <img width="300" height="300" :src="codeImg" />
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./form.vue";
import store from "@/store";
import {
  getCustomerList,
  getCustomerInfo,
  addCustomer,
  delCustomer,
  editCustomer,
  getAllUser,
  customerCode,
} from "@/api/data";
export default {
  name: "role",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      modalWidth: 600,
      addModal: false,
      editModal: false,
      resetFlag: false,
      showCodeModal: false,
      codeImg: "",
      editData: {},
      userIds: [],
      searchValue: "",
      userId: "",
      tableLoading: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        { title: "公司", key: "name", editable: true },
        { title: "地址", key: "address", editable: true },
        { title: "联系人", key: "contacts", editable: true },
        { title: "电话", key: "phone", editable: true },
        { title: "邮箱", key: "email", editable: true },
        { title: "所属业务员", key: "sales_name", editable: true },
        {
          title: "Handle",
          key: "handle",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showCode(params);
                    },
                  },
                },
                "二维码"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.viewUser(params);
                    },
                  },
                },
                "查看用户"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    showAddModal() {
      if (
        store.state.user.access.indexOf("Store Manager") != -1 ||
        store.state.user.access.indexOf("admin") != -1
      ) {
        getAllUser().then((res) => {
          if (res.data.code == 200) {
            this.$refs.addChild.setIsStoreManage(true);
            this.$refs.addChild.setUserData(res.data.data.records);
            this.addModal = true;
            this.resetFlag = !this.resetFlag;
          }
        });
      } else {
        // reset将表单数据清空，提前reset
        this.$refs.addChild.setIsStoreManage(false);
        this.$refs.addChild.setData(store.state.user);
        this.addModal = true;
      }
    },
    showEditModal(params) {
      if (
        store.state.user.access.indexOf("Store Manager") != -1 ||
        store.state.user.access.indexOf("admin") != -1
      ) {
        getAllUser().then((res) => {
          if (res.data.code == 200) {
            this.$refs.editChild.setIsStoreManage(true);
            this.$refs.editChild.setUserData(res.data.data.records);
          }
        });
      } else {
        this.$refs.editChild.setIsStoreManage(false);
        this.$refs.editChild.setData(store.state.user);
      }
      getCustomerInfo(params.row.id).then((res) => {
        var data = res.data.data;
        this.$refs.editChild.setEditData(data);
        this.editModal = true;
      });
      // })
      // .catch((err) => {
      //   this.$Message.error("失败!");
      // });
    },
    addSumit(formValidate) {
      addCustomer(formValidate)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
          this.resetFlag = !this.resetFlag;
        })
        .catch((err) => {
          this.$Message.error("失败!");
          this.resetFlag = !this.resetFlag;
        });
    },
    editSumit(formValidate) {
      editCustomer(formValidate)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
          this.resetFlag = !this.resetFlag;
        })
        .catch((err) => {
          this.$Message.error("失败!");
          this.resetFlag = !this.resetFlag;
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      if (this.userId == undefined) {
        this.userId = "";
      }
      this.setTableLoading(true);
      getCustomerList(
        this.page,
        this.pageSize,
        this.searchValue,
        this.userId
      ).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    showCode(params) {
      customerCode(params.row.id).then((res) => {
        if (res.data.code == 200) {
          this.codeImg = res.data.data;
        }
      });
      this.showCodeModal = true;
    },
    viewUser(params) {
      this.$router.push({
        name: "customer_user",
        query: { id: params.row.id },
      });
    },
    getAllUser() {
      getAllUser()
        .then((res) => {
          if (res.data.code == 200) {
            this.userIds = res.data.data.records;
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          delCustomer(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
      // params
      // row
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
    if (
      store.state.user.access.indexOf("Store Manager") != -1 ||
      store.state.user.access.indexOf("admin") != -1
    ) {
      this.getAllUser();
    }
  },
};
</script>
